var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m90.64,75.33v-24.16c0-4.34-3.53-7.87-7.87-7.87h-29.59v-18.63c5.38-1.41,9.36-6.31,9.36-12.12,0-6.92-5.63-12.55-12.55-12.55s-12.55,5.63-12.55,12.55c0,5.82,3.98,10.71,9.36,12.12v18.63h-29.59c-4.34,0-7.87,3.53-7.87,7.87v24.16c-5.38,1.41-9.36,6.31-9.36,12.12,0,6.92,5.63,12.55,12.55,12.55s12.55-5.63,12.55-12.55c0-5.82-3.98-10.71-9.36-12.12v-24.16c0-.83.67-1.5,1.5-1.5h29.59v25.66c-5.38,1.41-9.36,6.31-9.36,12.12,0,6.92,5.63,12.55,12.55,12.55s12.55-5.63,12.55-12.55c0-5.82-3.98-10.71-9.36-12.12v-25.66h29.59c.83,0,1.5.67,1.5,1.5v24.16c-5.38,1.41-9.36,6.31-9.36,12.12,0,6.92,5.63,12.55,12.55,12.55s12.55-5.63,12.55-12.55c0-5.82-3.98-10.71-9.36-12.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoles);
export default __webpack_public_path__ + "static/media/roles.26d168b32cb2cb0943b23de3d8f7505b.svg";
export { ForwardRef as ReactComponent };